import ApiService from "../api";

type IGetTokenBody = {
  username: string;
  password: string;
};

type IGetRefreshTokenBody = {
  refresh: string | undefined;
};

export const getTokenAPI = (data: IGetTokenBody) => {
  return ApiService.HttpPost<TokenResponse>({
    route: "api/token/",
    body: data,
  });
};

export const getTokenExternalAPI = () => {
  return ApiService.HttpGet<IResponse<TokenResponse>>({
    route: "register/token/external",
    token: true,
  });
};

export const getRefreshTokenAPI = (data: IGetRefreshTokenBody) => {
  return ApiService.HttpPost<TokenRefreshResponse>({
    route: "token/refresh/",
    body: data,
  });
};
